export function getLoadingRules(items, loading) {
  return items?.length === 0 && !loading
}
